import { types as T } from '../actions/action_types'
import { setIn } from '../common/utils'

const initialState = {
  route: null,
  isLoading: 0,
  userInfo: {
    userId: null
  },
  // this for checklist type dropdown
  estimate: {
    detail: {}
  }
}

const requestReg = /_REQUEST/
const resultReg = /_SUCCESS|_FAIL/

export default function reducer (state = initialState, action) {
  const isRequest =
    requestReg.test(action.type) &&
    action.type.indexOf('LOAD_USER_INFO') === -1
  const isResult =
    resultReg.test(action.type) && action.type.indexOf('LOAD_USER_INFO') === -1
  // set loading state for if any api calling
  if (isRequest) {
    state = { ...state, isLoading: state.isLoading + 1 }
  } else if (isResult) {
    let load = state.isLoading - 1
    if (load < 0) load = 0
    state = { ...state, isLoading: load }
  }
  // reducer action and set according in to reducer state
  switch (action.type) {
    case T.SET_ROUTE:
      return {
        ...state,
        route: action.data
      }

    case T.SET_USERINFO:
    case T.LOAD_USER_INFO_SUCCESS:
      return {
        ...state,
        userInfo: action.data
      }

    case T.CLEAR_DATA:
      return {
        ...initialState,
        route: state.route
      }

    case T.LOAD_ESTIMATE_SUCCESS:
      return setIn(['estimate', 'detail'], action.data, state)
    default:
      return state
  }
}
